<div class='header-container'>
  <div class='cbp-logo-container'>
    <img src='assets/logo-CBP.png' alt='CBP Logo'>
  </div>
  <div class='dmi-info-container'>
    <span class='current-status-title s-semi-bold'>International</span>
    <mat-button-toggle-group
      [formControl]='currentDashboardViewSelected'
      hideSingleSelectionIndicator='true'
      aria-label='Dashboard View'
      class='status-selection-container'
      (change)='onDashboardViewSelectedChange($event)'
    >
      <mat-button-toggle [value]='DashboardViewEnum.DashboardViewInternationalCatalogs'
                         data-cy='button-toggle-dashboard-view-international-catalogs'>
        <ng-icon name='saxBook1Outline' size='16px' class='icon'></ng-icon>
      </mat-button-toggle>
      <mat-button-toggle [value]='DashboardViewEnum.DashboardViewGlobal' data-cy='button-toggle-dashboard-view-global'>
        <ng-icon name='saxGlobalOutline' size='16px' class='icon'></ng-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class='country-selection-container'>
    <mat-select #selectCountry panelClass='country-select' [(value)]='countryCodeSelected'
                (selectionChange)='onCountrySelectedChange($event)' [hideSingleSelectionIndicator]='true'>
      <mat-select-trigger>
        <span *ngIf='countrySelected' class='s-semi-bold dsp-color-text-neutral'>
          {{ countrySelected.name }}
        </span>
      </mat-select-trigger>
      <mat-optgroup *ngFor='let zone of zoneList'>
        <span class='s-regular dsp-color-text-neutral'>{{ zone.name }}</span>
        <mat-option *ngFor='let country of zone.countryList' [value]='country.countryCode'>
          <span class='xs-regular dsp-color-text-quiet'>{{ country.name }}</span>
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </div>
  <div class='pos-display-container'>
    <a href='/dashboard/pos'>
      <span class='s-semi-bold'>PoS</span>
    </a>
  </div>
  <div class='navigation-bar-ending-container'>
    <div class='brand-selection-container'>
      <mat-select
        #selectSignature
        panelClass='brand-select'
        [(value)]='userSignatureInfoSelected'
        (selectionChange)='onSignatureSelectedChange($event)'
      >
        <mat-select-trigger>
          <div class='brand-selected-container'>
            <ng-container *ngIf='currentSignatureImg'>
              <div style='display:flex; align-items: center;'>
                <img *ngIf='signatureSelected?.displayImgOnly'
                     [src]='currentSignatureImg'
                     [srcset]='currentSignatureImgSrcset'
                     alt='signature logo'
                     class='brand-logo brand-logo-img-only'
                />
                <img *ngIf='!signatureSelected?.displayImgOnly'
                     [src]='currentSignatureImg'
                     [srcset]='currentSignatureImgSrcset'
                     fill='true'
                     alt='signature logo'
                     class='brand-logo brand-logo-img-with-text'
                />
              </div>
              <span *ngIf='!isSignatureImgDisplayImgOnly() && appServiceSelected'
                    class='brand-selected-text xxxs-regular'>{{ appServiceSelected.name }}</span>
            </ng-container>
            <ng-container *ngIf='!currentSignatureImg'>
              <span
                *ngIf='signatureSelected'
                class='s-semi-bold dsp-color-text-neutral'
              >
                {{ signatureSelected.name }}
              </span>
            </ng-container>
          </div>
        </mat-select-trigger>
        <mat-optgroup
          *ngFor='let referenceSignature of referenceSignatureList'
          [class.hide-label]='referenceSignature.appServiceList.length === 0'
        >
          <ng-container *ngIf='referenceSignature.appServiceList.length === 0'>
            <mat-option [value]='"signature_" + referenceSignature.id' [class.brand-option-solo-option]='true'>
              <span class='s-regular dsp-color-text-neutral'>{{ referenceSignature.name }}</span>
            </mat-option>
          </ng-container>

          <span
            *ngIf='referenceSignature.appServiceList.length !== 0'
            class='s-regular dsp-color-text-neutral'>
              {{ referenceSignature.name }}
            </span>
          <ng-container *ngIf='referenceSignature.appServiceList.length !== 0'>
            <mat-option
              *ngFor='let appService of referenceSignature.appServiceList'
              [value]='"signature_" + appService.signatureId + "_appService_" + appService.id'
              [class.brand-option-solo-option]='false'
            >
              <span class='xs-regular dsp-color-text-quiet'>{{ appService.name }}</span>
            </mat-option>
          </ng-container>
        </mat-optgroup>
      </mat-select>
    </div>
    <div class='user-info-parent-container'>
      <div class='user-info-container user-data-display-container'>
        <div class='user-detail-container'>
          <ng-container *ngIf='userInfo'>
            <span class='text xs-semi-bold'>{{ userInfo.displayName }}</span>
            <span class='sub-text xxxs-regular'>DMI</span>
          </ng-container>
        </div>
        <div class='user-icon-container'>
          <ng-icon name='saxProfileTickOutline' size='16px' class='icon'></ng-icon>
        </div>
      </div>
      <div
        role='button'
        tabindex='0'
        class='user-info-container user-management-link-container'
        (click)='redirectToUserManagementPage()'
        (keyup.enter)='redirectToUserManagementPage()'
      >
        <div class='user-detail-container'>
          <span class='text xs-semi-bold'>Users</span>
          <span class='sub-text xxxs-regular'>Management</span>
        </div>
        <div class='user-icon-container'>
          <ng-icon name='saxProfile2userOutline' size='16px' class='icon'></ng-icon>
        </div>
      </div>
    </div>
  </div>
</div>
